import fetch from 'utils/fetch';


export function otaProductList(productId,productName,agent,providerId,onSale,ccList,zoneName,psize,currentPage) {
    const data = {
        productId,
        productName,
        agent,
        providerId,
        ccList,
        onSale,
        zoneName,
        psize,
        currentPage
    };
    return fetch({
        url: '/otaProductList',
        method: 'get',
        params:data
    });
}
export function otaProductDetails(productId) {
    return fetch({
        url: '/otaProductDetail',
        method: 'get',
        params : {productId}
    });
}

export function otaAddProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/otaAddProduct',
        method: 'post',
        data
    });
}


export function otaUpProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/otaEditProduct',
        method: 'put',
        data
    });
}
export function otaDelProduct(requestData) {
    const data = {
        requestData
    };
    return fetch({
        url: '/otaDelProduct',
        method: 'post',
        data
    });
}




// WEBPACK FOOTER //
// ./src/api/otaProduct.js